(function(CartPage, $) {

  var bindUIActions = function() { 

    // Delete a gift wrap line item
    $('.remove-wrapper').on('click', function(){
      CartJS.removeItem( $(this).data('line') );
      setTimeout(function () {location.reload();}, 500);
    });

    // Delete an item and any gift wrappers for that item
    $('.remove-item').on('click', function(){
      var product_id = $(this).data('wrap-product-id').toString();
      var pid = '#remove-wrapper-' + product_id;
      CartJS.removeItemById(product_id);
      $(pid).click();
    });


    // Add/Remove a giftwrap item for a product 
    $('.gift-wrap-checkbox').on('change', function () {
      var product_id = $(this).data('wrap-product-id');

      if ( $(this).prop("checked") ) {
        var product_title = $(this).data('wrap-product'),
        gift_wrapping_pid = $('.gift-wrapping-pid').text();

        CartJS.addItem(gift_wrapping_pid, 1, {
          "For" : product_title,
          "ID" : product_id
        });

        setTimeout(function () {location.reload();}, 1000);
      } else {
        // Find the line-item for the chosen product's gift wrapping and delete
        var pid = '#remove-wrapper-' + product_id.toString();
        $(pid).click();
      }
    });
 
    // Set Checkboxes if gift wrap already in cart
    $( document ).ready( function() {
      $( ".wrapping-qty" ).each(function() {
        var product_id = $(this).data('wraps-product-id');
        var pid = product_id.toString();
        var checkbox_id = "#giftwraps_"+ pid;

        $(checkbox_id).prop('checked', true);
          
      });
    });
 
    $('.cart-qty').on('change', function () {
      var thisid = $(this).data('product-id'),
      thisline = $(this).data('line'),
      qty = $(this).val();
      
      // If wrapping quantity changes
      if ( $(this).hasClass('wrapping-qty')){

        // check the value of the qty-productID
        var original_id = $(this).data('wraps-product-id').toString();
        var original_qty_class = ".qty-" + original_id;
        var original_qty_val = $(original_qty_class).val();

        qty = parseInt(qty);
        original_qty_val = parseInt(original_qty_val);

        // Wrapping qty's max = max original product
        if( qty > original_qty_val) {
          CartJS.updateItem( thisline , original_qty_val);
        } else {
          CartJS.updateItem( thisline , qty);
        }

      } else { // Regular product quantity changes
        var pid = $(this).data('product-id');

        // Update the product
        CartJS.updateItemById(pid, qty);

        var wrapper_class = '.wraps-'+pid;
        // Check if wrapper

        if ( $(wrapper_class).length ) {  
          var wrapper_val = $(wrapper_class).val();

          wrapper_val = parseInt(wrapper_val);
          qty = parseInt(qty);

          if (wrapper_val > qty) {
            CartJS.updateItem( $(wrapper_class).data('line') , qty );
          }
        }
      }
      setTimeout(function () {location.reload();}, 1100);
    });
  };


  // Cannot have more gift wrap line items than actual product
  var verifyGiftWrapCount = function() {
    console.log("verifyGiftWrapCount");

    $( ".wrapping-qty" ).each(function() {
      var product_id   = $(this).data('wraps-product-id').toString();
      var product_qty  = $('.qty-'+product_id).val();
      var wrapping_qty = $(this).val();

      if (wrapping_qty > product_qty) {
        var line_item = $(this).data('line');
        console.log("line = " + line_item);
        CartJS.updateItem( line_item, product_qty );
      }

    });
  };

  CartPage.init = function() {
    bindUIActions();
  }; 

}(window.CartPage = window.CartPage || {}, jQuery, undefined));